import { Text } from '@user-portal/wikr-components';

import { FitnessLevelCardProps } from './types';

import * as S from './styled';

const FitnessLevelCard = ({ title, description, isActive, Icon, onClick, id }: FitnessLevelCardProps) => (
    <S.CardWrapper
        isActive={isActive}
        onClick={() => onClick(id)}
        data-locator={isActive ? 'activeFitnessLevelCard' : 'fitnessLevelCard'}
    >
        <div>
            <Text mb={4} bold>
                {title}
            </Text>
            <S.Description type="small-text" color="text-secondary">
                {description}
            </S.Description>
        </div>
        <Icon />
    </S.CardWrapper>
);

export default FitnessLevelCard;
